import { CreateQuoteRequest } from "../components/TradeInModal/Grading/types";
import { QuotesResponse } from "../components/TradeInModal/PaymentOptions/PaymentOptions";
import { noticeError } from "../../../utils/newrelic/requests";

export type CreateQuoteResponse = {
  status: number;
  error?: string;
  quote?: QuotesResponse;
};
export const createQuote = async (
  baseUrl: string,
  requestBody: CreateQuoteRequest,
  abortController: AbortController | null = null,
): Promise<CreateQuoteResponse> => {
  const url = `${baseUrl}/quotes`;
  return await fetch(url, {
    method: "POST",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
    signal: abortController?.signal,
  })
    .then(async function (response: Response) {
      const { status } = response;
      if (response.ok && (status >= 200 || status <= 299)) {
        return { status, quote: await response.json() };
      }

      if (status === 422) {
        noticeError("Create quote request failed", {
          message: (await response.json()).message,
        });
      }

      return { status, error: "Trade in create quote failed" };
    })
    .catch(() => {
      return { status: 400, error: "Trade in create quote failed" };
    });
};
